
import Filtros from './Filtros';
import Filtro from './Filtro';
import React, { useState, useEffect, useCallback } from 'react';
import ColumnChart from './graficos/ColumnChart';
import PieChart from './graficos/PieChart';
import MapChart from './graficos/MapChart';
import MapLeaflet from './graficos/MapLeaflet';
import brasil_desenho from './geo/brasil-ibge.json'
import aux_mapa from './helper/aux_mapa'
import { FcSearch, FcBusinessman, FcLibrary, FcNext } from "react-icons/fc";
import Clock from 'react-live-clock';
import { useSearchParams } from 'react-router-dom'
import Marquee from 'react-fast-marquee'

function MainMapa() {
  const [estado, setEstado] = useState(35);
  const [fiscalizacao, setFiscalizacao] = useState(268);
  const [destino, setDestino] = useState("Todos");
  const [estados, setEstados] = useState([{ value: "Todos", label: "..." }]);
  const [fiscalizacoes, setFiscalizacoes] = useState([{ value: "...", label: "..." }]);
  const [fiscalizacaoOperacao, setFiscalizacaoOperacao] = useState([]);
  const [quantidadeEntidades, setQuantidadeEntidades] = useState({});
  const [quantidadeAgentes, setQuantidadeAgentes] = useState(0);
  const [quantidadeMunicipios, setQuantidadeMunicipios] = useState(0);
  const [destinos, setDestinos] = useState([{ value: "Todos", label: "..." }]);
  const [dadosTrimestre, setDadosTrimestre] = useState([]);
  const [dadosAnual, setDadosAnual] = useState([]);
  const [dadosMapa, setDadosMapa] = useState([]);
  const [noticias, setNoticias] = useState([]);
  const [desenhoMapa, setDesenhoMapa] = useState(brasil_desenho);
  const [updateCounter, setUpdateCounter] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams()

  const refreshParam = searchParams.get('refresh')
  const marqueeSpeed = searchParams.get('marquee') || 100

  const refresh_timer = parseInt(refreshParam) >= 30 && parseInt(refreshParam) <= 600 ? parseInt(refreshParam) : 40

  const fetchEstados = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/estados`)
    const json = await data.json()
    setEstados(json)
  }
  const fetchDestinos = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/materiais/destinos`)
    const json = await data.json()
    setDestinos(json)
  }
  const fetchFiscalizacoes = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes`)
    const json = await data.json()
    setFiscalizacoes(json)
  }

  const fetchQuantidadeAgentes = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/agentes/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    setQuantidadeAgentes(json)
  }

  const fetchQuantidadeEntidades = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/entidades/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    setQuantidadeEntidades(json)
  }

  const fetchQuantidadeMunicipios = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/municipios/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    setQuantidadeMunicipios(json)
  }

  const fetchDadosMapa = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/fotos/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    setDadosMapa(json)
  }

  const fetchNoticias = async () => {

    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/noticias/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    setNoticias(json)
  }

  const fetchFiscalizacaoOperacao = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    const ordenado = ordena_fo_operacao(json)
    setFiscalizacaoOperacao(ordenado)
  }

  // const fetch_dados_por_trimestre = useCallback(async () => {
  //   const parametros = qs.stringify({ ano, destino })
  //   const url = `${process.env.REACT_APP_API_URL}/materiais/trimestre?${parametros}`
  //   const data = await fetch(url)
  //   const json = await data.json()
  //   setDadosTrimestre(json)
  // }, [ano, destino])

  // const fetchDadosAnual = useCallback(async () => {
  //   const parametros = qs.stringify({ ano, destino })
  //   const url = `${process.env.REACT_APP_API_URL}/materiais/anual?${parametros}`
  //   const data = await fetch(url)
  //   const json = await data.json()
  //   setDadosAnual(json)
  // }, [ano, destino])

  useEffect(() => {
    const interval = setInterval(() => {
      setUpdateCounter((prev) => { return prev + 1 })
    }, refresh_timer * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchEstados()
    fetchFiscalizacoes()
  }, []);

  useEffect(() => {
    fetchFiscalizacaoOperacao()
    fetchDadosMapa()
    fetchNoticias()
    fetchQuantidadeEntidades()
    fetchQuantidadeAgentes()
    fetchQuantidadeMunicipios()
  }, [fiscalizacao, estado, updateCounter]);

  // const fetchDadosAnual = useCallback(async () => {
  //   const parametros = qs.stringify({ ano, destino })
  //   const url = `${process.env.REACT_APP_API_URL}/materiais/anual?${parametros}`
  //   const data = await fetch(url)
  //   const json = await data.json()
  //   setDadosAnual(json)
  // }, [ano, destino])

  // useEffect(() => {
  //   fetchDadosAnual()
  // }, [fetchDadosAnual]);



  const handleEstadoChange = (e) => {
    const valor = e.target.value
    const estadoIndex = e.nativeEvent.target.selectedIndex;
    const estadoText = e.nativeEvent.target[estadoIndex].text;
    const estadoValue = e.nativeEvent.target[estadoIndex].value;
    setEstado(estadoValue)
    const file = aux_mapa.get_geoJson_by_key(parseInt(e.target.value))

    setDesenhoMapa(file)

    setDadosMapa(dadosMapa)
  }
  const handleFiscalizacaoChange = (e) => {
    const valor = e.target.value
    setFiscalizacao(parseInt(valor))
    fetchDadosMapa()
  }

  const getDataNameAndY = (dados) => {
    return dados.map(x => {
      return { name: x.descricao, y: x.value }
    })
  }

  const getDataNameAndDataArray = (dados) => {
    const result = dados.map(x => {
      return { name: x.descricao, data: [x.value] }
    })
    return result
  }

  const getChartLabels = (dados) => {
    return dados.reduce((acc, curr) => {
      acc.push(curr.descricao);
      return acc
    }, new Array())
  }

  const handleMapClick = (event) => {
    console.log(event);
    const id_estado = event?.point?.options?.id
    if (id_estado) {
      const file = aux_mapa.get_geoJson_by_key(event.point.options.id)
      setDesenhoMapa(file)
      setEstado(id_estado)

    }
  }

  const getNaoFiscalizadas = () => {
    const total = quantidadeEntidades?.total || 0
    const fiscalizadas = quantidadeEntidades?.fiscalizadas || 0
    return parseInt(total) - parseInt(fiscalizadas)
  }

  const getFiscalizadas = () => {
    const fiscalizadas = quantidadeEntidades?.fiscalizadas || 0
    return parseInt(fiscalizadas)
  }

  const getFiscalizadasPercentual = () => {
    const fiscalizadas = parseInt(quantidadeEntidades?.fiscalizadas) || 0
    const total = parseInt(quantidadeEntidades?.total) || 0
    if (total) {
      let valor = parseInt(fiscalizadas) / parseInt(total);
      valor = valor * 100
      valor = valor.toLocaleString('pt-BR', {
        minimumIntegerDigits: 2,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })
      return valor
    }
    return parseInt(0)
  }

  const get_titulo_principal = (idfo) => {
    switch (idfo) {
      case 268: return (<span className='titulo-operacao' style={{fontSize: '28px'}}>ACESSIBILIDADE</span>)
      case 266: return (<span className='titulo-operacao' style={{fontSize: '22px'}}>ALMOXARIFADO DA EDUCAÇÃO E UNIFORMES ESCOLARES</span>)
      case 265: return (<span className='titulo-operacao' style={{fontSize: '28px'}}>GESTÃO DOS RESÍDUOS SÓLIDOS</span>)
      case 263: return (<span className='titulo-operacao' style={{fontSize: '28px'}}>GESTÃO DE MEDICAMENTOS</span>)
      case 258: return (<span className='titulo-operacao' style={{fontSize: '22px'}}>ALMOXARIFADO DA EDUCAÇÃO E UNIFORMES ESCOLARES</span>)
      case 243: return (<span className='titulo-operacao'>ALIMENTAÇÃO ESCOLAR</span>)
      case 242: return (<span className='titulo-operacao' style={{fontSize: '36px'}}>GESTÃO DE TEATROS E <br />GINÁSIOS ESPORTIVOS</span>)
      case 236: return (<span className='titulo-operacao'>PRAIAS E RIOS</span>)
      case 229: return (<span className='titulo-operacao'>ESTRATÉGIA SAÚDE DA FAMÍLIA</span>)
      case 225: return (<span className='titulo-operacao'>ENFRENTAMENTO À VIOLÊNCIA CONTRA A MULHER</span>)
      case 217: return (<span className='titulo-operacao'>UNIDADES DE SAÚDE GERENCIADAS POR ORGANIZAÇÕES SOCIAIS</span>)
      case 214: return (<span className='titulo-operacao'>TRANSFERÊNCIAS ESPECIAIS</span>)
      case 210: return (<span className='titulo-operacao'>ESCOLA EM TEMPO INTEGRAL</span>)
      case 208: return (<span className='titulo-operacao'>RESÍDUOS SÓLIDOS</span>)
      default: return (<span className='titulo-operacao'></span>)
    }
  }

  const get_subtitulo_principal = (idfo) => {
    switch (idfo) {
      case 268: return 'V FISCALIZAÇÃO ORDENADA / 2026'
      case 266: return 'IV FISCALIZAÇÃO ORDENADA / 2026'
      case 265: return 'III FISCALIZAÇÃO ORDENADA / 2026'
      case 263: return 'II FISCALIZAÇÃO ORDENADA / 2026'
      case 258: return 'I FISCALIZAÇÃO ORDENADA / 2026'
      case 243: return 'III FISCALIZAÇÃO ORDENADA / 2025'
      case 242: return 'II FISCALIZAÇÃO ORDENADA / 2025'
      case 236: return 'I FISCALIZAÇÃO ORDENADA / 2025'
      case 229: return 'II FISCALIZAÇÃO ORDENADA / 2024'
      case 225: return 'I FISCALIZAÇÃO ORDENADA / 2024'
      case 217: return 'VI FISCALIZAÇÃO ORDENADA / 2023'
      case 214: return 'V FISCALIZAÇÃO ORDENADA / 2023'
      case 210: return 'IV FISCALIZAÇÃO ORDENADA / 2023'
      case 208: return 'III FISCALIZAÇÃO ORDENADA / 2023'
    }
  }
  const get_pre_subtitulo_principal = (idfo) => {
    switch (idfo) {
      case 214: return (<>EMENDAS PIX <br/></>)
      default: return ''
    }
  }  
  
  const get_texto_descricao_entidade = (idfo) => {
    switch (idfo) {
      case 236: return ("Praias/Rios Fiscalizados")
      // case 242: return ("Teatros/Ginásios Fiscalizados")
      default: return 'Entidades Fiscalizadas'
    }
  }

  const getPieData = (x) => {

    if (x?.[2]?.descricao) {

      // x = x.filter(y=> { return ['Sim', 'Não', 'SIM', 'NÃO'].includes(y.descricao) } )

      x = x.map(y => {
        if(y.descricao.includes('Prejudicado')) {
          return {...y, descricao: 'Prejudicado'}
        }
        return y
      })
      const sorted = x.sort((a, b) => {
        const order = { "Não": 0, "Sim": 1, 'Prejudicado':2, 'Parcial': 3  };
        return (order[a.descricao]) - (order[b.descricao.trim()]);
      });

    //   return [
    //     { name: get_desc(sorted?.[0]?.descricao), y: sorted?.[0]?.value },
    //     { name: get_desc(sorted?.[1]?.descricao), y: sorted?.[1]?.value },
    //     { name: get_desc(sorted?.[2]?.descricao), y: sorted?.[2]?.value }]
    // }
    return [
      { name: get_desc(sorted?.[0]?.descricao), y: sorted?.[0]?.value },
      { name: get_desc(sorted?.[1]?.descricao), y: sorted?.[1]?.value },
      { name: get_desc(sorted?.[2]?.descricao), y: sorted?.[2]?.value }]
  }

  if (x?.[1]?.descricao) {
    const sorted = x.sort((a, b) => {
      const order = { "Não": 0, "Sim": 1, 'Prejudicado':2, 'Parcial': 3 };
      return (order[a.descricao]) - (order[b.descricao.trim()]);
    });
    return [
      { name: get_desc(sorted?.[0]?.descricao), y: sorted?.[0]?.value },
      { name: get_desc(sorted?.[1]?.descricao), y: sorted?.[1]?.value }]
  }
    let p1 = { name: x?.[0]?.descricao, y: x?.[0]?.value }
    if (x?.[0]?.descricao == 'Sim' && x?.[1]?.descricao == 'Não' || x?.[1]?.descricao == 'Sim' && x?.[0]?.descricao == 'Não') {
      return [{ name: x?.[0]?.descricao, y: x?.[0]?.value }, { name: x?.[1]?.descricao, y: x?.[1]?.value }]
    }

    if (x?.[0]?.descricao == 'Sim') {
      return [{ name: x?.[0]?.descricao, y: x?.[0]?.value }, { name: 'Não', y: 0 }]
    }

    if (x?.[1]?.descricao == 'Sim') {
      return [{ name: x?.[1]?.descricao, y: x?.[0]?.value }, { name: 'Não', y: 0 }]
    }

    if (x?.[0]?.descricao == 'Não') {
      return [{ name: 'Sim', y: 0 }, { name: x?.[0]?.descricao, y: x?.[0]?.value }]
    }

    if (x?.[1]?.descricao == 'Não') {
      return [{ name: 'Sim', y: 0 }, { name: x?.[1]?.descricao, y: x?.[0]?.value }]
    }



    return [{ name: x?.[0]?.descricao, y: x?.[0]?.value }, { name: x?.[1]?.descricao, y: x?.[1]?.value }]
  }

  const changeEstadoHandler = (codigo) => {
    setEstado(codigo)
  }

  const imprimeTextografico = (x) => {


    if (x.id === 24025) { //1
      return (<span style={{ fontSize: '14px' }}>{`Com relação às transferências especiais recebidas do GOVERNO
       FEDERAL em 2023 (artigo 166-A, inciso I, da Constituição Federal), o Município elaborou o 
       Plano de Aplicação dos Recursos?`}</span>)
    }

    if (x.id === 24068) { //6
      return (<span style={{ fontSize: '14px' }}>{`Por amostragem, a transferência especial 
      em análise foi aplicada pelo Município em despesa de capital ou em despesa 
      corrente, de acordo com a natureza do repasse recebido?`}</span>)
    }
    

    if (x.id === 24133) { //7
      return (<span style={{ fontSize: '14px' }}>{`Foram prestadas informações no portal do GOVERNO FEDERAL
     (Transferegov.br), para fins de transparência e controle social de todas as transferências especiais, 
     os dados e informações referentes à execução dos recursos recebidos?`}</span>)
    }
    switch (fiscalizacao) {
      case 210: return (<span style={{ fontSize: '14px' }}>{x?.label}</span>)
      case 214: return (<span style={{ fontSize: '14px' }}>{x?.label}</span>)
      case 225: return (<span style={{ fontSize: '14px' }}>{x?.label}</span>)
      case 229: return (<span style={{ fontSize: '14px' }}>{x?.label}</span>)
      case 236: return (<span style={{ fontSize: '14px' }}>{x?.label}</span>)
      case 242: return (<span style={{ fontSize: '16px' }}>{x?.label}</span>)
      default: return (<span style={{ fontSize: '16px' }}>{x?.label}</span>)
    }
    // if( [23220,23162,23222].includes(x.id)) {
    if ([23220, 23162, 23222].includes(x.id)) {
      return (<span style={{ fontSize: '14px' }}>{x?.label}</span>)
    }
    return x?.label
  }

  const imprime_titulo = (indice) => {


    switch (fiscalizacao) {
      case 210:
        switch (indice) {
          case 0: return (<div className="titulo-grafico-15">ESTADUAL</div>)
          case 3: return (<div className="titulo-grafico-15">MUNICIPAL</div>)
          case 6: return (<div className="titulo-grafico-15">ESCOLAS</div>)
          default: return (<></>)
        }
        case 225:
        switch (indice) {
          case 0: return (<div className="titulo-grafico-15">DDM - DELEGACIA DE DEFESA DA MULHER</div>)
          case 3: return (<div className="titulo-grafico-15">IML - INSTITUTO MÉDICO LEGAL</div>)
          case 6: return (<div className="titulo-grafico-15">UH - UNIDADE HOSPITALAR ESTADUAL COM SERVIÇOS ESPECIALIZADOS EM SAÚDE DA MULHER</div>)
          default: return (<></>)
        }
        case 236:
          switch (indice) {
            case 0: return (<div className="titulo-grafico-15">PRAIAS LITORÂNEAS</div>)
            case 3: return (<div className="titulo-grafico-15">PRAIAS INTERIORES</div>)
            case 6: return (<div className="titulo-grafico-15">RIOS</div>)
            default: return (<></>)
          }
          case 242:
            switch (indice) {
              case 0: return (<div className="titulo-grafico-15">TEATROS</div>)
              case 3: return (<div className="titulo-grafico-15">GINÁSIOS ESPORTIVOS</div>)
              // case 6: return (<div className="titulo-grafico-15">RIOS</div>)
              default: return (<></>)
            }
      default: return (<></>)
    }



  }

  const imprime_grafico = (x, i) => {
    return (
      <PieChart height="150px" titulo="" labelY="Quantidade" labelX={["asdasd", "asd"]}
        dados={getPieData(x)}
        showLabels={true} legend={true} showPercentual bgColor={get_chart_bgcolor(i)} />
      // bgColor="#faf7e7"
    )
  }

  const get_desc = (s) => {
    if (s.includes('Prejudicado')) {
      return 'Prejudicado'.toUpperCase()
    } else {
      return s.toUpperCase()
    }
  }
  const get_chart_bgcolor = (i) => {
    if (fiscalizacao === 210) {
      if (i < 3) {
        return '#faf7e7'
      } else if (i < 6) {
        return '#e7faf7'
      }
      else return '#f7e7fa'
    }
    if (fiscalizacao === 225) {
      if (i < 3) {
        return '#e7faf7'
      } else if (i < 6) {
        return '#f7e7fa'
      }
      else return '#faf7e7'
    }

    if (fiscalizacao === 236) {
      if (i < 3) {
        return '#faf7e7'
      } else if (i < 6) {
        return '#f7e7fa'
      }
      else return '#e7faf7'
    }
    return '#faf7e7'
  }

  const get_logos = (fiscalizacao) => {
    switch (fiscalizacao) {
      case 236:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_3.png`} className="logo-fo-100" />
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_6.png`} className="logo-fo-100" />
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_11.png`} className="logo-fo-100" />
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_14.png`} className="logo-fo-100" />
            </>
        )      
        case 242:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_3.png`} className="logo-fo-100" />
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_4.png`} className="logo-fo-100" />
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_11.png`} className="logo-fo-100" />
            <img src={process.env.PUBLIC_URL + `/img/logos/ods_16.png`} className="logo-fo-100" />
            </>
        )
        case 258:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} />
            </>
        )
        case 243:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} />
            </>
        )
        case 263:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} />
            </>
        )
        case 265:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} />
            </>
        )
        case 266:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} />
            </>
        )
        case 268:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} />
            </>
        )
        default:
        return (
          <>
            <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} className="logo-fo" />
            </>
        )
  }
}

  const imprime_box_grafico = (x, i) => {

    switch (fiscalizacao) {
      case 210:
        return (
          <>
            {imprime_titulo(i)}
            <div key={x?.[0]?.label} style={{ backgroundColor: get_chart_bgcolor(i), height: '230px' }} className="grafico15 sombra">
              {/* {x[0].label} */}
              {imprimeTextografico(x[0])}
              {imprime_grafico(x, i)}
            </div></>
        )
        case 225:
          return (
            <>
              {imprime_titulo(i)}
              <div key={x?.[0]?.label} style={{ backgroundColor: get_chart_bgcolor(i), height: '230px' }} className="grafico15 sombra">
                {/* {x[0].label} */}
                {imprimeTextografico(x[0])}
                {imprime_grafico(x, i)}
              </div></>
          )
          case 236:
          return (
            <>
              {imprime_titulo(i)}
              <div key={x?.[0]?.label} style={{ backgroundColor: get_chart_bgcolor(i), height: '230px' }} className="grafico15 sombra">
                {/* {x[0].label} */}
                {imprimeTextografico(x[0])}
                {imprime_grafico(x, i)}
              </div></>
          )          
          case 242:
          return (
            <>
              {imprime_titulo(x[0].ordem || i)}
              <div key={x?.[0]?.label} style={{ backgroundColor: get_chart_bgcolor(i), height: '230px' }} className="grafico15 sombra">
                {/* {x[0].label} */}
                {imprimeTextografico(x[0])}
                {imprime_grafico(x, i)}
              </div></>
          )
      default:
        return (
          <>
            <div key={x?.[0]?.label} style={{ backgroundColor: get_chart_bgcolor(i) }} className="grafico15 sombra">
              {/* {x[0].label} */}
              {imprimeTextografico(x[0])}
              {imprime_grafico(x, i)}
            </div></>
        )
    }
  }


  const ordena_fo_operacao = (data) => {
    // console.log(data)
    function compare(a, b) {
      return a[0].ordem - b[0].ordem;
    }

    const fo = data.sort(compare);

    return fo
  }

  const get_graficos = (lado) => {
    if(lado === 1 && fiscalizacao === 242) {
      return (<>{fiscalizacaoOperacao.slice(0,3).map((x, i) => {
        return (imprime_box_grafico(x, i))
      })}</>)
    }
    if(lado === 1) return 
    if(lado === 2 && fiscalizacao === 242) {
      return (<>{fiscalizacaoOperacao.slice(3,6).map((x, i) => {
        return (imprime_box_grafico(x, i))
      })}</>)
    } 
    return (<>{fiscalizacaoOperacao.map((x, i) => {
      return (imprime_box_grafico(x, i))
    })}</>)
  }

  return (

    <div className="materiais">
      <Filtros>
        {/* <Filtro key="filtroDestino" id="filtroDestino" name="Destino" data={destinos} onChange={handleDestinoChange} /> */}
        {/* <Filtro key="filtroEstado" id="filtroEstado" name="Estado" data={estados} value={estado} onChange={handleEstadoChange} /> */}
        <Filtro key="filtroFiscalizacao" id="filtroFiscalizacao" name="Fiscalizações" data={fiscalizacoes} onChange={handleFiscalizacaoChange} />
      </Filtros>

      <div className="main_layout">
        <div className='logo-itens sombra' style={{ width: '93%' }}>
          <div className='center-vertical-row' style={{ width: '95%', justifyContent: 'space-between' }}>
            <img src={process.env.PUBLIC_URL + "/logo_tcesp.png"} className="logo" />
            {/* <img src={process.env.PUBLIC_URL + `/img/logos/${fiscalizacao}.png`} className="logo-fo" /> */}

            { get_logos(fiscalizacao) }
            <div className='center-vertical-column'>
              {get_titulo_principal(fiscalizacao)}
              {<span className='subtitulo-operacao'>{get_pre_subtitulo_principal(fiscalizacao)}
              {get_subtitulo_principal(fiscalizacao)}</span>}
              {/* <img src={process.env.PUBLIC_URL + "/img/subtitulo-fo.png"} style={{ width: '750px' }} /> */}
              {/* <img src={process.env.PUBLIC_URL + "/img/banner_bottom.png"} style={{ width: '750px' }} /> */}
            </div>

            <div className="box-info-geral">
            <div className="itens-gerais-fo">
              <div><FcSearch /> {quantidadeEntidades?.total} {get_texto_descricao_entidade(fiscalizacao)} </div>
              {/* <div><FcSearch /> 229 Entidades Fiscalizadas </div> */}
              <div><FcBusinessman /> {quantidadeAgentes} Auditores</div>
              <div><FcLibrary /> {quantidadeMunicipios} Municípios </div>
            </div>
            <div style={{ width: '150px', height: '150px' }}>
              <PieChart height="150px" titulo="" labelY="Quantidade" labelX={["asdasd", "asd"]}
                dados={[{ name: 'Fiscalizadas', y: getFiscalizadas() }, { name: 'Não Fiscalizadas', y: getNaoFiscalizadas() }]}
                showLabels={false} legend={false} colors={["#902254", "#AD5D81"]} showPercentual={false} />
            </div>
            <p style={{ fontSize: 18 }}><strong>{quantidadeEntidades?.fiscalizadas} de {quantidadeEntidades?.total}<br /> {getFiscalizadasPercentual()}%</strong></p>
          </div>
          </div>
        </div>
        <div>
        <div className="graficos" id="graficos1">

            {/* {fiscalizacaoOperacao.length} */}
            { get_graficos(1) }
           


          </div>
          <div id="mapaFO" key="mapa">

            {/* <MapChart dados={dadosMapa} desenhoMapa={desenhoMapa} clickMapa={handleMapClick} serieName={estado} showLabels={false} /> */}
            <MapLeaflet desenhoMapa={desenhoMapa} dados={dadosMapa} estado={estado} fiscalizacao={fiscalizacao}
              fiscalizacaoOperacao={fiscalizacaoOperacao} estadoHandler={changeEstadoHandler} />
            {/* <ColumnChart titulo="Materiais por Trimestre e Tipo" showLabels
              labels={['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']}
              labelY="Quantidade" stack={true} dados={dadosTrimestre} /> */}
          </div>

          <div className="graficos" id="graficos2">
            {/* <video width="320" height="240" autoPlay loop muted src="https://www.w3schools.com/tags/movie.mp4" /> */}

            { get_graficos(2) }


          </div>
        </div>
      </div>
      <div className="rodape">
        <div className="noticias sombra">
          <div className="marquee">
            <div>
              <Marquee speed={marqueeSpeed}  >
                <>
                  {noticias.map((x, index) => {
                    return (<><FcNext />&nbsp;<span key={index + Math.random() * 1000}>{x.descricao} - {x.comentario} - {x.data_envio}  &nbsp;</span></>)
                  })}
                </>
              </Marquee>
            </div>
          </div>
        </div>
        <div className="horario sombra">
          <Clock format={'HH:mm:ss'} ticking={true} timezone={'America/Sao_Paulo'} />
        </div>
      </div>
    </div>
  );
}

export default MainMapa;
